import { render, staticRenderFns } from "./ResultsListBillItem.vue?vue&type=template&id=13ef5f8a"
import script from "./ResultsListBillItem.vue?vue&type=script&lang=js"
export * from "./ResultsListBillItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports